<template>
  <v-expansion-panels v-model="expanded" v-if="currentMission != null">
    <v-expansion-panel
      v-if="!customEvasiveLoading && relevantCustomEvasiveErrors.length > 0"
    >
      <v-expansion-panel-header color="error">
        <v-row class="d-flex align-center justify-center">
          <span class="font-weight-bold mt-1 text-truncate white--text"
            >{{ relevantCustomEvasiveErrors.length }} error{{
              relevantCustomEvasiveErrors.length === 1 ? '' : 's'
            }}
            encountered while loading custom scenarios
          </span>
        </v-row>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-data-table
          dense
          :headers="header"
          :items="relevantCustomEvasiveErrors"
        >
          <template v-slot:[`item.buttons`]="{ item }">
            <v-row>
              <v-btn
                @click="deleteCustomScenarioByName(item.name)"
                icon
                color="red darken-2"
                x-small
              >
                <v-icon>delete</v-icon>
              </v-btn>
              <CustomEvasiveScenarioEditButton
                :scenario="
                  customEvasiveScenarios.find(
                    (scenario) => scenario.name === item.name
                  )
                "
                buttonColor="blue"
                :iconOnly="true"
                buttonIconName="edit"
                size="x-small"
              />
            </v-row>
          </template>
        </v-data-table>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
import resultsDescription from '../../tools/resultsDescription.json'
import dataTools from '../../tools/data.js'
import { mapGetters, mapActions } from 'vuex'
import errorMixin from '../../mixins/logHandler.js'
import CustomEvasiveScenarioEditButton from './CustomEvasiveScenarioEditButton'

export default {
  name: 'EvasiveManeuverDashboard',
  mixins: [errorMixin],
  components: { CustomEvasiveScenarioEditButton },

  data() {
    return {
      expanded: [],
      header: [
        { text: 'Name', value: 'name', align: 'center' },
        { text: 'Message', value: 'message', align: 'center' },
        {
          text: '',
          value: 'buttons',
          align: 'center',
          sortable: false,
          width: '50px'
        }
      ]
    }
  },

  computed: {
    ...mapGetters({
      currentMission: 'currentMission',
      customEvasiveScenarios: 'customEvasiveScenarios',
      customEvasiveLoading: 'customEvasiveLoading',
      customEvasiveErrors: 'customEvasiveErrors'
    }),
    relevantCustomEvasiveErrors() {
      const relevantCustomEvasiveScenariosNames = this.customEvasiveScenarios
        .filter((scenario) => scenario.missionId === this.currentMission.id)
        .map((scenario) => scenario.name)
      return this.customEvasiveErrors.filter((error) =>
        relevantCustomEvasiveScenariosNames.includes(error.name)
      )
    }
  },
  methods: {
    ...mapActions(['refreshCustomEvasiveScenarios']),
    deleteCustomScenarioByName(name) {
      const scenarioToDelete = this.customEvasiveScenarios.find(
        (scenario) => scenario.name === name
      )
      if (scenarioToDelete != null) {
        this.$http
          .delete(
            '/users/' +
              this.currentUser.id +
              '/customevasivescenariodefinitions/' +
              scenarioToDelete.id
          )
          .then((response) => {
            this.refreshCustomEvasiveScenarios()
          })
          .catch((e) => {
            self.displayMessage(
              'Error deleting custom scenarios. ',
              e,
              'NumericalMissionErrorDisplay',
              'error'
            )
          })
      }
    }
  }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css?family=Roboto');
</style>
